import { render, staticRenderFns } from "./DistributorDetail.vue?vue&type=template&id=44a1303a&scoped=true&"
import script from "./DistributorDetail.vue?vue&type=script&lang=js&"
export * from "./DistributorDetail.vue?vue&type=script&lang=js&"
import style0 from "./DistributorDetail.vue?vue&type=style&index=0&id=44a1303a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a1303a",
  null
  
)

export default component.exports